import api from './api';

type ApiEnvelope<T> = {
  success: boolean;
  data: T;
  message?: string;
};

function unwrapData<T>(response: any, fallback: T): T {
  const payload = response?.data ?? response?.result ?? response ?? fallback;
  return payload === null || payload === undefined ? fallback : (payload as T);
}

function envelope<T>(response: any, fallback: T): ApiEnvelope<T> {
  return {
    success: response?.success !== false,
    data: unwrapData(response, fallback),
    message: response?.message,
  };
}

export async function listReleaseTemplates() {
  const response = await api.get<{ success: boolean; data: Record<string, any>; message?: string }>(`/juben/release/templates`);
  const data = unwrapData(response, {});
  const templates = (data as any)?.by_id ?? data;
  return {
    success: response?.success !== false,
    data: templates && typeof templates === 'object' && !Array.isArray(templates) ? templates : {},
    message: response?.message,
  };
}

export async function calculateRoi(payload: {
  views: number;
  ctr: number;
  cvr: number;
  arpu: number;
  cost: number;
}) {
  const response = await api.post<{ success: boolean; data: any }>(`/juben/release/roi`, payload);
  return envelope(response, {});
}

export async function generateChecklist(payload: {
  platform: string;
  title: string;
  episodes: number;
}) {
  const response = await api.post<{ success: boolean; data: any }>(`/juben/release/checklist`, payload);
  return envelope(response, {});
}
